//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { ITwitterFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_TWITTER_POST_DETAILS_FORM_STATE: ITwitterFormState = {
  postType: UniversalPostType.TwitterMediaPost,
  postNow: false,
};

export const TWITTER_POST_DETAILS_SMART_INPUT_USER_SEARCH_COUNT = 20;
export const MAX_TWEET_LENGTH = 280;

export const TwitterPostDetailsFormFieldErrorText = {
  NoMediaOrText: 'Please add either media or text to this post.',
  TextTooLong: 'Please enter 280 characters or less.',
} as const;
